import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import CacheKeys from '../../../cache/CacheKeys.js'
import CacheManager from '../../../cache/CacheManager.js'
import CustomersPageUI from './CustomersPageUI.js'

class CustomersPageSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      account: null,
      customerList: null,
      searchFilter: '',
      createCustomerMode: false,
      updateCustomerMode: false,
      selectedCustomer: null,
    }
  }

  render() {
    return (
      <CustomersPageUI
        context={this.props.context}
        account={this.state.account}
        customerList={this.state.customerList}
        stateList={this.state.stateList}
        searchFilter={this.state.searchFilter}
        onSearchFilterChange={this.onSearchFilterChange}
        onRefreshClick={this.onRefreshClick}
        //
        createCustomerMode={this.state.createCustomerMode}
        onCreateCustomerClick={() => { this.setState({ createCustomerMode: true }) }}
        onCancelCreateCustomer={() => { this.setState({ createCustomerMode: false }) }}

        updateCustomerMode={this.state.updateCustomerMode}
        onUpdateCustomerClick={this.onUpdateCustomerClick}
        onCancelUpdateCustomer={() => { this.setState({ updateCustomerMode: false }) }}
        selectedCustomer={this.state.selectedCustomer}
      />
    )
  }

  componentDidMount() {
    let context = this.props.context
    this.getAccounts(context)
    this.getCustomers(context)
    this.getState(context)
  }
  
  onUpdateCustomerClick = (event) => {
    let customerId = event.currentTarget.getAttribute('data-id')
    console.log(customerId);
    let selectedCustomer = this.state.customerList.filter(p => p.customerId === customerId)[0]
    this.setState({updateCustomerMode: true, selectedCustomer: selectedCustomer})
  }

  getAccounts(context) {
    let cacheManager = new CacheManager({
      resource: `/api/su/accounts/${this.props.match.params.accountId}`,
      cacheKey: CacheKeys.Accounts(this.props.match.params.accountId),
      callback: this.getAccountsCallback,
      ttlInSecs: 600
    })
    cacheManager.getObject2(context)
  }

  getAccountsCallback = (response) => {
    this.setState({ account: response.account })
  }

  getCustomers(context) {
    let cacheManager = new CacheManager({
      resource: `/api/su/accounts/${this.props.match.params.accountId}/customers`,
      cacheKey: CacheKeys.Customers(this.props.match.params.accountId),
      callback: this.getCustomersCallback,
      ttlInSecs: 600
    })
    cacheManager.getObject2(context)
  }

  getCustomersCallback = (response) => {
    this.setState({
      customerList: response.customerList
    })
  }

  getState(context) {
    let cacheManager = new CacheManager({
      resource: `/api/pub/indiaStates`,
      cacheKey: CacheKeys.State(),
      callback: this.getStateCallback,
      ttlInSecs: 3600
    })
    cacheManager.getObject2(context)
  }

  getStateCallback = (response) => {
    let stateList = response.indiaStateList.map((state) => {
      return { key: state.code, value: state.name }
    });
    this.setState({ errorList: response.errorList, stateList: stateList })
  }

  onSearchFilterChange = (event) => {
    let searchFilter = event.target.value
    this.setState({ searchFilter: searchFilter })
    this.applyFilters(this.state.customerList, searchFilter)
  }

  onRefreshClick = () => {
    let context = this.props.context
    CacheManager.removeObject(CacheKeys.Accounts(this.props.match.params.accountId))
    CacheManager.removeObject(CacheKeys.Customers(this.props.match.params.accountId))
    CacheManager.removeObject(CacheKeys.State())
    this.setState({ account: null, customerList: null },
      this.getAccounts(context),
      this.getCustomers(context),
      this.getState(context)
    )
  }
}

export default withRouter(CustomersPageSF)
